import React, { useEffect } from "react";
import Popup from "reactjs-popup";
import { stationMasterApiConfig } from "../config/apiConfig.js";
import {
  groupInfo,
  dataObject,
  validate,
  subStationTableHeader,
  subStationTableItems
} from "../config/stationMasterForm.js";
import FormColumn from "./FormColumn.js";
import { Prompt } from "react-router-dom";
import "./Form.css";
import "./ChallanForm.css";
import "./AutoSuggest.css";
import useForm from "./useForm";
import "./popup.css";
import Autosuggest from "react-autosuggest";
import { SERVER_URL } from "../config/config.js";
import DynamicViewTable from "./DynamicViewTable.js";

const StationMasterForm = ({ sessionObject }) => {
  const contentStyle = {
    maxWidth: "600px",
    width: "90%",
  };

  let variablesFromSession = {
    station_from: String(sessionObject.sessionVariables.branch_id),
    station_from_name: sessionObject.sessionVariables.branch_name,
    created_from: String(sessionObject.sessionVariables.branch_id),
    created_by: String(sessionObject.sessionVariables.user_id),
    company_id: sessionObject.sessionVariables.company_id ?? "1",
  };

  const myForm = useForm(
    "StationMaster",
    validate,
    { ...dataObject, ...variablesFromSession },
    stationMasterApiConfig
  );

  const getAdditionalInfoForSuggestionFetch = (fieldInfoObject) => {
    // if (fieldInfoObject.name == "vehicle_no"){
    //   return {"limit": "10"};
    // }
    // console.log(fieldInfoObject.name);
    if(fieldInfoObject.name == "to_pay_account_name") {
        let additionalInfoObject = {};
        additionalInfoObject.is_account_related = "1";
        return additionalInfoObject;
    }
    return null;
  };

  const checkDisabledCondition = (fieldInfo) => {
    return ""
  };

  const checkVisibilityCondition = (fieldInfo) => {
    return true
  };

  let partyNameFieldInfo = {
    label: "Party Name",
    className: "form-row",
    labelClassName: "form-label",
    inputClassName: "form-input",
    name: "consignor_name",
    type: "text",
    placeHolder: "",
    apiConfigKey: "getConsignorSuggestions",
    url: SERVER_URL + "/consignor/",
    suggestionKeyword: "consignor_name",
    suggestionKeywordExtra: "consignor_gst",
    suggestionKeywordForFetchApiArgs: "name",
    suggestionChooseQueryKeyword: "consignor_id",
    suggestionSchema: {
      consignor_name: "consignor_name",
      consignor_gst: "consignor_gst",
      consignor_id: "consignor_id",
    },
    apiCallRequiredOnGetValue: true,
    toValidate: true,
    regExpValidation: "[a-zA-z]",
    keyboardNavigationMap: {
        Enter: "save_button",
      },
    idClearanceNeeded: "consignor_id",
    inputDataNeededInSuggestions: false,
    inputDataFilter: {
      pay_type: "same",
    },
  };
  let toPayAccountFieldInfo = {
    label: "",
    className: "form-row",
    labelClassName: "form-label",
    inputClassName: "form-input",
    name: "to_pay_account_name",
    type: "text",
    placeHolder: "",
    apiConfigKey: "getConsignorSuggestions",
    url: SERVER_URL + "/consignor/",
    suggestionKeyword: "consignor_name",
    suggestionKeywordExtra: "consignor_gst",
    suggestionKeywordForFetchApiArgs: "name",
    suggestionChooseQueryKeyword: "consignor_id",
    suggestionSchema: {
      consignor_name: "to_pay_account_name",
    //   consignor_gst: "consignor_gst",
      consignor_id: "to_pay_account_id",
        // to_pay_account_name: "consignor_name",
        // to_pay_account_id: "consignor_id",
    },
    apiCallRequiredOnGetValue: true,
    toValidate: true,
    regExpValidation: "[a-zA-z]",
    keyboardNavigationMap: {
        Enter: "pincode",
    },
    idClearanceNeeded: "consignor_id",
    inputDataNeededInSuggestions: false,
    inputDataFilter: {
      pay_type: "same",
    },
  };

  const consignorFieldInfo = {
    label: "Sub Station Name",
    className: "form-row",
    labelClassName: "form-label",
    inputClassName: "form-input",
    name: "sub_station_name",
    type: "text",
    placeHolder: "",
    apiConfigKey: "getTransporterSuggestions",
    url: SERVER_URL + "/branch/",
    suggestionKeyword: "name",
    suggestionKeywordExtra: "consignor_gst",
    suggestionKeywordForFetchApiArgs: "name",
    suggestionChooseQueryKeyword: "consignor_id",
    suggestionChooseQueryKeywordCustom: (suggestion, pageState) => {
      return (
        String(suggestion.consignor_id) +
        "?bilty_type=" +
        String(pageState.pay_type)
      );
    },
    suggestionSchema: {
      transporter_name: "consignor_name",
      transporter_gst: "consignor_gst",
      transporter_id: "consignor_id",
    },
    apiCallRequiredOnGetValue: true,
    toValidate: true,
    regExpValidation: "[a-zA-z]",
    keyboardNavigationMap: {
      Enter: "consignor_gst",
    },
    idClearanceNeeded: "consignor_id",
    inputDataNeededInSuggestions: false,
    inputDataFilter: {
      pay_type: "same",
    },
  };

  const fetchSubStationOnEnter = async (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      const branchName = myForm.pageState.sub_station_name?.trim();

      if (!branchName) return;

      try {
        const url = `${SERVER_URL}/branch/get_sub_station_for_branch?branch_name=${encodeURIComponent(branchName)}`;
        const response = await fetch(url, { method: "POST" });

        const result = await response.json();

        if (!response.ok || result?.error || !Array.isArray(result)) {
          const errorMessage = result?.error || "Failed to fetch sub station";
          throw new Error(errorMessage);
        }

        if (result.length === 0) {
          throw new Error("No Sub Station found");
        }

        const newStations = result.map((station) => ({
          sub_station_name: station.name,
          sub_station_id: station.branch_id,
        }));

        const updatedStations = [
          ...(myForm.pageState.sub_station_info || []),
          ...newStations,
        ].map((station, index) => ({
          sub_station_id: station.sub_station_id,
          sub_station_name: station.sub_station_name,
        }));

        myForm.setPageState({
          ...myForm.pageState,
          sub_station_info: updatedStations,
          sub_station_name: "",
        });

        console.log("Updated Sub Stations:", updatedStations);
      } catch (error) {
        console.error("Error fetching sub station:", error.message);
        myForm.setPopupError(error.message);
        myForm.setPageMode("error");
      }
    }
  };

  const callSubStationApi = async () => {
    try {
      const branchId = myForm.pageState.branch_id;
      const subStationIds = myForm.pageState?.sub_station_info?.map(s => s.sub_station_id) || [];

      if (subStationIds.length === 0) return;

      const response = await fetch(
        `${SERVER_URL}/branch/branch-sub-branch-mapping?branch_id=${branchId}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(subStationIds),
        }
      );

      const result = await response.json();

      if (!response.ok || result?.error) {
        throw new Error(result?.error || "Failed to save sub-stations");
      }

      return result;
    } catch (err) {
      myForm.setPopupError(err.message);
      myForm.setPageMode("error");
      throw err;
    }
  };

  useEffect(() => {
    if (myForm.pageState.sub_branches) {
      myForm.setPageState(prev => ({
        ...prev,
        sub_station_info: (prev.sub_branches || []).map(b => ({
          sub_station_id: b.branch_id,
          sub_station_name: b.name
        }))
      }));
    }
  }, [myForm.pageState.sub_branches]);

  return (
    <div className="challan-form-container">
      <div>
        <Popup
          // trigger={<button className="button"> Open Modal </button>}
          open={myForm.pageMode == "submitted" || myForm.pageMode == "error"}
          modal
          contentStyle={contentStyle}
          closeOnDocumentClick={false}
        >
          {(close) => (
            <div className="pop-up-container">
              <div className="pop-up-header">
                {" "}
                {myForm.pageMode == "submitted" ? (
                  <div>Station Saving Successful </div>
                ) : (
                  <div>Error In Station Module </div>
                )}
                <div>
                  <a className="pop-up-close btn" onClick={close}>
                    &times;
                  </a>
                </div>
              </div>
              {myForm.pageMode == "submitted" ? (
                <div className="pop-up-content">
                  {" "}
                  Station Master Saved Successfully:-
                  <br />
                  <div className="pop-up-fields">
                    <div className="pop-up-field">
                      <div className="pop-up-field-label">Station Name</div>
                      <div className="pop-up-field-value">
                        {myForm.pageState.name}
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="pop-up-content">
                  {" "}
                  Error in Station Master with the following info:-
                  <br />
                  <div className="pop-up-fields">
                    <div className="pop-up-field">
                      <div className="pop-up-field-label">Error:</div>
                      <div className="pop-up-field-value">
                        {myForm.popupError}
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <div className="pop-up-actions">
                <button
                  className="pop-up-button"
                  onClick={() => {
                    if (myForm.pageMode == "submitted") {
                      // sessionObject.saveSessionVariableByField("last_bilty_no", {"last_bilty_no":myForm.pageState.bilty_no})
                      myForm.setPageState({
                        ...dataObject,
                        ...variablesFromSession,
                      });
                      myForm.setPageMode("write");
                      window.location.reload();
                      close();
                    } else {
                      myForm.setPageMode("write");
                      close();
                    }
                  }}
                >
                  Okay
                </button>
              </div>
            </div>
          )}
        </Popup>
      </div>

      <div className="form-header">Station Master</div>
      <div onSubmit={myForm.handleSubmit} className="form" noValidate>
        <div className="form-title">
          <div className="form-row">
            
            <label className="form-label">
              Id: {myForm.pageState.branch_id}
            </label>
            <label style={{display: 'none'}} className="form-label" >Is Branch?:</label>
            <select
              className="chform-input-suffix"
              style={{display: 'none'}}
              onChange={(newValue) => {
                myForm.handleChangeForSelect(newValue, "is_branch");
              }}
              name="is_branch"
              ref={(a) => myForm.storeInputReferenceForSelect(a, "is_branch")}
              // disabled={checkDisabledCondition({ name: "bilty_type" })}
              value={myForm.pageState["is_branch"]}
              onKeyPress={(a) => {
                if (a.key == "Enter") {
                  a.preventDefault();
                  myForm.makeFocusOnParticularField("name");
                }
              }}
            >
              <option value="1" key="Y">
                Y
              </option>
              <option value="0" key="N">
                N
              </option>
            </select>
          </div>
        </div>
        <div className="form-input-content-block-0">
          <div className="form-field-left">
            <FormColumn
              groupInfo={groupInfo}
              groupName="group-1"
              checkDisabledCondition={checkDisabledCondition}
              checkVisibilityCondition={checkVisibilityCondition}
              myFormObj={myForm}
              getAdditionalInfoForSuggestionFetch={getAdditionalInfoForSuggestionFetch}
            />
          </div>
          <div className="form-field-right">
            <FormColumn
              groupInfo={groupInfo}
              groupName="group-2"
              checkDisabledCondition={checkDisabledCondition}
              checkVisibilityCondition={checkVisibilityCondition}
              myFormObj={myForm}
              getAdditionalInfoForSuggestionFetch={getAdditionalInfoForSuggestionFetch}
            />
            <>
            <div className="form-row">
            <label className="form-label">Freight Bill Account</label>
            <Autosuggest
                id={partyNameFieldInfo["name"]}
                // suggestions={myForm.suggestions}
                suggestions = {(myForm.suggestions != undefined) ? myForm.suggestions : ""}  // changes made for removing error that was caused by undefined suggestion
                onSuggestionsFetchRequested={(a) =>
                    myForm.onSuggestionsFetchRequestedDebounced(
                    a,
                    (b) =>
                        myForm.suggestionFetchApi(
                        partyNameFieldInfo,
                        b,
                        getAdditionalInfoForSuggestionFetch(partyNameFieldInfo)
                        )
                    )
                }
                onSuggestionsClearRequested={() =>
                    myForm.onSuggestionsClearRequested(partyNameFieldInfo)
                }
                getSuggestionValue={(suggestion) =>
                    suggestion[partyNameFieldInfo.suggestionKeyword]
                }
                onSuggestionSelected={(a, b) =>
                    myForm.getSuggestionValue(
                    b.suggestion,
                    partyNameFieldInfo,
                    myForm.performSuggestions,
                    myForm.updatePageStateForGetSuggestion
                    )
                }
                renderSuggestion={(a) =>
                    myForm.renderSuggestion(a, partyNameFieldInfo)
                }
                highlightFirstSuggestion={true}
                ref={(a) => myForm.storeInputReference(a, false)}
                inputProps={{
                    placeholder: partyNameFieldInfo["placeholder"],
                    value: String(myForm.pageState[partyNameFieldInfo["name"]]),
                    onChange: (a, b) => {
                    myForm.onChangeAutoSuggest(a, b, partyNameFieldInfo);
                    },
                    onBlur: () => {
                    partyNameFieldInfo["toValidate"]
                        ? myForm.onblurValidator(partyNameFieldInfo)
                        : {};
                    },
                    onKeyPress: (a) =>
                    myForm.onKeyPressForKeyNav(a, partyNameFieldInfo),
                    // disabled: checkDisabledCondition(partyNameFieldInfo),
                }}
            />
            </div>
            <FormColumn
              groupInfo={groupInfo}
              groupName="group-3"
              checkDisabledCondition={checkDisabledCondition}
              checkVisibilityCondition={checkVisibilityCondition}
              myFormObj={myForm}
              getAdditionalInfoForSuggestionFetch={getAdditionalInfoForSuggestionFetch}
            />

            {process.env.REACT_APP_CLIENT === "bbac" && (
              <div className="table-container-2">
                <div className={consignorFieldInfo["className"]}>
                  <label className={consignorFieldInfo["labelClassName"]}>
                    {consignorFieldInfo["label"]}
                  </label>
                  <Autosuggest
                    id={consignorFieldInfo["name"]}
                    suggestions={myForm.suggestions}
                    onSuggestionsFetchRequested={(a) =>
                      myForm.onSuggestionsFetchRequested(a, (b) =>
                        myForm.suggestionFetchApi(
                          consignorFieldInfo,
                          b,
                          getAdditionalInfoForSuggestionFetch(consignorFieldInfo)
                        )
                      )
                    }
                    onSuggestionsClearRequested={() =>
                      myForm.onSuggestionsClearRequested(consignorFieldInfo)
                    }
                    getSuggestionValue={(suggestion) =>
                      suggestion[consignorFieldInfo.suggestionKeyword]
                    }
                    onSuggestionSelected={(a, b) =>
                      myForm.getSuggestionValue(
                        b.suggestion,
                        consignorFieldInfo,
                        myForm.performSuggestions,
                        myForm.updatePageStateForGetSuggestion
                      )
                    }
                    renderSuggestion={(a) =>
                      myForm.renderSuggestion(a, consignorFieldInfo)
                    }
                    highlightFirstSuggestion={true}
                    ref={(a) => myForm.storeInputReference(a, false)}
                    inputProps={{
                      placeholder: consignorFieldInfo["placeholder"],
                      value: String(myForm.pageState[consignorFieldInfo["name"]]),
                      onChange: (a, b) => {
                        myForm.onChangeAutoSuggest(a, b, consignorFieldInfo);
                      },
                      onBlur: () => myForm.onblurValidator(consignorFieldInfo),
                      onKeyPress: fetchSubStationOnEnter,
                      disabled: checkDisabledCondition(consignorFieldInfo),
                    }}
                  />
                </div>

                <DynamicViewTable
                  tableHeader={subStationTableHeader}
                  tableItems={subStationTableItems}
                  tableValues={myForm.pageState["sub_station_info"]}
                  setPageStateByField={myForm.setPageStateByField}
                  pageStateArray={myForm.pageState["sub_station_info"]}
                  fieldMapping="sub_station_info"
                />
              </div>
            )}
      </>
          </div>
        </div>
        <div className="form-footer">
          <button
            onClick={async (e) => {
              e.preventDefault();
              try {
                await callSubStationApi();

                await myForm.handleSubmit(e);
              } catch (err) {
                console.log("Sub-station API failed, form submit skipped");
              }
            }}
            type="button"
            className="btn btn-primary"
            ref={(a) => myForm.storeInputReferenceForSelect(a, "save_button")}
          >
            Save
          </button>
          {/* <div className="status">{myForm.renderSubmitApiResponseStatus()}</div> */}
        </div>
      </div>
    </div>
  );
};

export default StationMasterForm;
